import { render, staticRenderFns } from "./CustomerOffers.vue?vue&type=template&id=780c9812&scoped=true"
import script from "./CustomerOffers.vue?vue&type=script&lang=js"
export * from "./CustomerOffers.vue?vue&type=script&lang=js"
import style0 from "./CustomerOffers.vue?vue&type=style&index=0&id=780c9812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c9812",
  null
  
)

export default component.exports